// スマホだと2回タップしないとリンク先に飛ばない問題の対策
window.ontouchstart = function() {};
window.addEventListener('touchstart', function() {}, true);
window.addEventListener('touchstart', function() {}, false);

// 年数（コピーライト）
$(function(){
  var year = new Date().getFullYear();
  $("#year").html(year);
});

//Menu
// var state = false;
// var pos;
// $("#menu-btn").on("click",function(){
//   if (state == false) {
//     pos = $(window).scrollTop();
//     $('body').addClass('is-fixed').css({'top': -pos});
//     state = true;
//   } else {
//     $('body').removeClass('is-fixed').css({'top': 0});
//     window.scrollTo(0, pos);
//     state = false;
//   }

//   $("#menu").toggleClass("open");
// });

// アコーディオン
$(function() {
  $('.accordion-btn').on('click', function() {
    $(this).children().siblings('.accordion-mark').toggleClass('active');
    $(this).siblings('.link-list').slideToggle();
  });

  $('.entry-accordion-title').on('click', function() {
    $(this).toggleClass('active');
    $(this).siblings('.entry-accordion-text').slideToggle();
  });
});
